<template>

	<v-menu
	:value="show"
	offset-y
	:activator="activator"
	v-on:input="$emit('hide')"
	>
		<v-list>
			<v-list-tile
			v-for="(item, i) in items[page]" :key="i"
			@click="item.action"
			:disabled="typeof item.disabled == 'function' ? item.disabled() : item.disabled">
				<v-list-tile-action v-if="item.icon">
					<v-icon small>{{item.icon}}</v-icon>
				</v-list-tile-action>
				<v-list-tile-action v-if="item.checkbox">
					<v-checkbox :value="item.checkbox()" readonly></v-checkbox>
				</v-list-tile-action>
				<v-list-tile-content>
					<v-list-tile-title small v-html="item.title">
					</v-list-tile-title>
					<v-list-tile-sub-title small>
						{{item.subtitle}}
					</v-list-tile-sub-title>
				</v-list-tile-content>
				<v-list-tile-action v-if="item.icon2">
					<v-icon small>{{item.icon2}}</v-icon>
				</v-list-tile-action>
			</v-list-tile>
			
			<v-divider></v-divider>
			
			<v-list-tile v-if="page < items.length-1" @click.stop="page++">
				<v-list-tile-action>
				</v-list-tile-action>
				<v-list-tile-content>
					<v-list-tile-title>
						Next
					</v-list-tile-title>
					<v-list-tile-sub-title small>
						Go to page {{page+2}} of {{items.length}}
					</v-list-tile-sub-title>
				</v-list-tile-content>
				<v-list-tile-action>
					<v-icon small>fa-chevron-right</v-icon>
				</v-list-tile-action>
			</v-list-tile>
			
			<v-list-tile v-if="page > 0" @click.stop="page--">
				<v-list-tile-action>
					<v-icon small>fa-chevron-left</v-icon>
				</v-list-tile-action>
				<v-list-tile-content>
					<v-list-tile-title>
						Previous
					</v-list-tile-title>
					<v-list-tile-sub-title small>
						Go to page {{page}} of {{items.length}}
					</v-list-tile-sub-title>
				</v-list-tile-content>
				<v-list-tile-action>
				</v-list-tile-action>
			</v-list-tile>
			
		</v-list>
</v-menu>

</template>


<script>
import Vuex from 'vuex'

import api from '../../assets/js/api-instance'

export default {
	name: "FollowTokenListMenu",
	
	props: [ "show", "activator", "token_id" ],
	
	data () {
		return {
			items: [
				[
					{
						action: () => this.toggleTracking(this.token_id),
						checkbox: () => this.tracking[this.token_id],
						title: "Track",
						subtitle: "Pan updates into view"
					},
					{
						action: () => this.emit('zoom', {token_id: this.token_id}),
						icon: 'fa-search-plus',
						title: 'Zoom',
						subtitle: "Zoom to data extents"
					},
					{
						disabled: () => !this.maybeMoreFixes,
						action: () => this.getMore(this.token_id),
						icon: 'fa-angle-double-down',
						title: "Load more",
						subtitle: "Fetch older data"
					},
					{
						//action: () => console.log("TODO: Not implemented"),
						action: () => this.emit('dialogue', {tokenShare: this.token_id}),
						icon: 'fa-share-alt',
						title: "Shares …",
						subtitle: "Share this entry"
					},
					{
						action: () => this.emit('dialogue', {tokenInfo: this.token_id}),
						icon: 'fa-info',
						title: "Token info …",
						subtitle: "See details, links, …"
					}
				],
				[
					{
						action: () => this.emit('dialogue', {scripting: true}),
						icon: 'fa-filter',
						title: "Scripting …",
						subtitle: "Manipulate the data"
					},
					{
						action: () => this.emit('dialogue', {tokenEdit: this.token_id}),
						icon: 'fa-edit',
						title: "Edit …",
						subtitle: "Change name, etc.",
					},
					{
						action: () => this.download(this.token_id),
						icon: 'fa-cloud-download-alt',
						title: "Download …",
						subtitle: "Download as GeoJSON",
					},
					{
						action: () => this.emit('dialogue', {recordingOptions: this.token_id}),
						icon: 'fa-save',
						title: "Record …",
						subtitle: "Record to this channel",
						icon2: 'fa-flask'
					},
					{
						action: () => this.confirmRemoveToken(this.token_id),
						icon: 'fa-trash-alt',
						title: "<span style='color: red'>Delete …</span>",
						subtitle: "Irreversible action!",
						icon2: 'fa-exclamation-triangle'
					},
				]
			],
			page: 0
		};
	},
	
	computed: {
		tracking () {
			const entries =
				Object.entries(this.$store.state.tokenData.tokenState)
				.map(entry => [ entry[0], entry[1].tracking ]);
			
			// Node 10 does not have Object.fromEntries ☺
			return entries
			.reduce((obj, { 0: key, 1: val }) => Object.assign(obj, { [key]: val }), {});
		},
		
		maybeMoreFixes () {
			const tokenState = this.$store.state.tokenData.tokenState[this.token_id];
			return tokenState && tokenState.hasOwnProperty('maybeMore')
				? tokenState.maybeMore
				: true;
		}
	},
	
	methods: {
		emit (event, payload) {
			this.$root.$emit(event, payload);
		},
		
		toggleTracking (token_id) {
			this.$store.commit('setTokenTracking', {token_id: token_id, tracking: !this.tracking[token_id]});
		},
		
		getMore (token_id) {
			this.$store.dispatch('getMoreFixes', {token_id: token_id});
		},
		
		download (token_id) {
			const token = this.$store.state.tokenData.tokens.find(t => t.token_id == token_id);
			const name = token ? token.metadata.name : undefined;
			console.log("Downloading", name, token_id);
			let dwnld = api.downloadFixes(token_id, {name});
			console.log(dwnld);
			dwnld
			.then(id => console.log("Download finished", id))
			.catch(error => console.log("Download failed", error));
		},
		
		confirmRemoveToken (token_id) {
			const token = this.$store.state.tokenData.tokens.find(t => t.token_id == token_id);
			console.log("DELETE - TOKEN", token, token_id);
			if (token) {
				this.emit('dialogue', {
					confirmYesNo: {
						title: `Remove token ‘${token.metadata && token.metadata.name || token.token_id}’`,
						text: "Are you sure you want to <b>permanently</b> remove this token and all its data? This action cannot be undone.",
						textYes: "Remove",
						textNo: "Keep",
						actionYes: () => this.$store.dispatch('removeToken', {token_id: token_id})
					}
				});
			}
		}
	}
};

</script>
